var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.85 13.8C28.41 13.8 29.73 15.5 29.85 18H34.27C34.13 14.56 32.03 11.4 27.85 10.38V6H21.85V10.32C21.07 10.48 20.35 10.74 19.65 11.04L22.67 14.06C23.31 13.9 24.05 13.8 24.85 13.8ZM10.79 7.84L7.97 10.66L14.85 17.54C14.85 21.7 17.97 23.98 22.67 25.36L29.69 32.38C29.01 33.36 27.59 34.2 24.85 34.2C20.73 34.2 19.11 32.36 18.89 30H14.49C14.73 34.38 18.01 36.84 21.85 37.66V42H27.85V37.7C29.77 37.34 31.51 36.6 32.77 35.46L37.21 39.9L40.03 37.08L10.79 7.84Z",
    fill: "#FFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOff);
export default __webpack_public_path__ + "static/media/money_off.6e0636f763d2100d5826dd9b8a0d551e.svg";
export { ForwardRef as ReactComponent };